import { createSlice } from "@reduxjs/toolkit";
import {
  getCertificateStatusBuilder,
  applyCertificateBuilder,
  getUserApplicationsBuilder,
  getAllApplicationsBuilder,
  approveApplicationBuilder,
} from "./builder.js";
import { LOGOUT } from "../../../utils/constants";

const initialState = {
  // Certificate status for current course
  certificateStatus: null,
  statusLoading: false,

  // Application process
  applicationLoading: false,

  // User applications
  userApplications: [],
  applicationsLoading: false,

  // Admin functionality
  allApplications: [],
  allApplicationsLoading: false,
  reviewLoading: false,

  // Error handling
  error: null,
};

export const certificatesSlice = createSlice({
  name: "certificates",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCertificateStatus: (state) => {
      state.certificateStatus = null;
    },
  },
  extraReducers: (builder) => {
    getCertificateStatusBuilder(builder);
    applyCertificateBuilder(builder);
    getUserApplicationsBuilder(builder);
    getAllApplicationsBuilder(builder);
    approveApplicationBuilder(builder);

    builder.addCase(LOGOUT, () => ({ ...initialState }));
  },
});

export const {
  clearError,
  clearCertificateStatus,
} = certificatesSlice.actions;

// Selectors
export const selectCertificateStatus = (state) => state.certificates.certificateStatus;
export const selectStatusLoading = (state) => state.certificates.statusLoading;
export const selectApplicationLoading = (state) => state.certificates.applicationLoading;
export const selectUserApplications = (state) => state.certificates.userApplications;
export const selectApplicationsLoading = (state) => state.certificates.applicationsLoading;
export const selectCertificatesError = (state) => state.certificates.error;

// Admin selectors
export const selectAllApplications = (state) => state.certificates.allApplications;
export const selectAllApplicationsLoading = (state) => state.certificates.allApplicationsLoading;
export const selectReviewLoading = (state) => state.certificates.reviewLoading;

export default certificatesSlice.reducer;